import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";
import { Link } from "react-router-dom";

const Standards = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Service Standards" 
        description="Requirements and expectations for all BlueLux technicians"
      >
        <section className="space-y-8">
          <div className="bg-card border-2 border-primary rounded-lg p-6">
            <p className="text-lg font-semibold text-primary">
              Rule: If it's not logged in the App, it didn't happen.
            </p>
            <p className="text-muted-foreground mt-2">
              Jobs not fully logged are not eligible for payment.
            </p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-sm text-muted-foreground">
              📋 For step-by-step service procedures, see the{" "}
              <Link to="/wiki/procedures/service-workflow" className="text-primary hover:underline font-medium">
                Service Workflow
              </Link>{" "}
              guide.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-4">Professional Conduct</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Maintain a clean and professional appearance</li>
              <li>Wear BlueLux-branded shirt, clean work pants/shorts, closed-toe shoes</li>
              <li>Treat customers with courtesy and respect</li>
              <li>No smoking, vaping, or intoxicants while on duty or at customer properties</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-4">App Requirements</h2>
            <p className="text-muted-foreground mb-4">
              For each pool/spa visit, you must:
            </p>
            <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
              <li>Start your route on time</li>
              <li>Complete the full checklist</li>
              <li>Record water chemistry readings</li>
              <li>Upload before and after photos</li>
              <li>Record all chemical additions</li>
              <li>Mark job complete only after all steps are submitted</li>
            </ol>
            <p className="text-sm text-muted-foreground mt-4">
              See{" "}
              <Link to="/wiki/service/app-documentation" className="text-primary hover:underline">
                App Documentation
              </Link>{" "}
              for detailed instructions.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-4">Reliability</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Arrive on time for scheduled routes</li>
              <li>Communicate cancellations or delays immediately through the App</li>
              <li>Cover all assigned pools fully — skipping steps is prohibited</li>
              <li>BlueLux vehicles are for BlueLux jobs only</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-4">Confidentiality</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Customer information is confidential and property of BlueLux</li>
              <li>Do not share or use customer info outside of assigned work</li>
              <li>Direct solicitation of BlueLux customers is prohibited</li>
            </ul>
          </div>

          <div className="bg-destructive/10 border border-destructive rounded-lg p-6 mt-8">
            <h3 className="text-lg font-semibold text-destructive mb-3">Performance Enforcement</h3>
            <p className="text-sm text-muted-foreground">
              Failure to meet these standards may result in:
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground mt-2 space-y-1">
              <li>Withholding of incentives or bonuses</li>
              <li>Removal from routes</li>
              <li>Termination of engagement</li>
              <li>Potential legal action</li>
            </ul>
          </div>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default Standards;
